import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const Name = styled.th`
  width: 25%;
  text-align: left;
  vertical-align: middle;
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const Description = styled.td`
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`
